import React from 'react'
import { DetailsField } from '../components/issue-details-layout'
import type { UseIssueFieldConfig } from './use-issue-field-config'
import type { IssueFormFieldValue, IssueFormMode } from './types'

interface ConfiguredFieldProps {
  config: UseIssueFieldConfig
  field: IssueFormFieldValue
  mode: IssueFormMode
  label: string
  full?: boolean
  elevated?: boolean
  /** Show the required marker only while the form is editable. */
  markRequired?: boolean
}

/**
 * A `DetailsField` that renders nothing when the company has hidden the field,
 * and carries the company's required marker and label override when it hasn't.
 */
export const ConfiguredField: React.FC<
  React.PropsWithChildren<ConfiguredFieldProps>
> = ({
  config,
  field,
  mode,
  label,
  full,
  elevated,
  markRequired = true,
  children,
}) => {
  if (!config.isVisible(field, mode)) return null

  return (
    <DetailsField
      label={config.labelFor(field, label)}
      required={markRequired && config.isRequired(field, mode)}
      full={full}
      elevated={elevated}
    >
      {children}
    </DetailsField>
  )
}
